<template>
  <div>
    <FormWizardStepHeader
      title="Select countries you invest in"
      description="Select one or more countries you invest in"
    >
    </FormWizardStepHeader>

    <AlertSlideUpDown :show="$v.countryCodes.$error"
      >Please select a country</AlertSlideUpDown
    >

    <FormItem required class="pb-40">
      <b-form-checkbox-group
        v-model="form.countryCodes"
        buttons
        class="btn-group-outline-spaced-big mb-20"
        @input="$v.countryCodes.$touch()"
      >
        <b-form-checkbox
          v-for="country in countries"
          :key="country.value"
          :value="country.value"
          >{{ country.text }}</b-form-checkbox
        >
      </b-form-checkbox-group>
    </FormItem>

    <FormItem
      label="If you only invest in specific regions in a country, please specify below. Otherwise leave empty."
      invalid-message="The regions must be between 0 and 500 characters long"
      :state="$v.regions.$dirty ? !$v.regions.$error : null"
    >
      <template slot="description">
        <FormInputLengthCounter
          label="Add regions between 0 and 500 characters"
          :min="100"
          :max="500"
          :text="form.regions"
        />
      </template>

      <template>
        <b-form-textarea
          v-model="form.regions"
          :rows="5"
          :max-rows="10"
          placeholder="E.g. Denmark: Copenhagen region only"
          @blur="$v.regions.$touch()"
        />
      </template>
    </FormItem>
  </div>
</template>

<script>
import FormItem from '@/components/form/FormItem'
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
import AlertSlideUpDown from '@/components/AlertSlideUpDown'
import FormInputLengthCounter from '@/components/form/FormInputLengthCounter'

export default {
  name: 'CompanyFormStepCountry',
  components: {
    AlertSlideUpDown,
    FormWizardStepHeader,
    FormInputLengthCounter,
    FormItem
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        ...this.value
      }
    }
  },
  computed: {
    countries() {
      return this.$store.getters['meta/siteCountriesExNI']
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
      }
    }
  }
}
</script>
